import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Breadcrums from "../../common/breadcrumbs";
import { formateDateWithMonth } from "../../../../utils/commonfunction";
import { adminNotificationDetails } from "../../services/notification.services";

const ViewNotification = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();
  const [details, setDetails] = useState(null);
  const [loader, setLoader] = useState(true);

  const breadcrumbs = [
    { title: t("link_dashboard"), url: "/admin/dashboard" },
    { title: "Notifications", url: "/admin/notification" },
    { title: "View Notification", url: "" },
  ];

  useEffect(() => {
    setLoader(true);
    adminNotificationDetails(id)
      .then((response) => {
        if (response?.success) {
          setDetails(response?.data || null);
        }
      })
      .catch((error) => {
        console.log("notificationDetailsError ====> ", error);
      })
      .finally(() => {
        setLoader(false);
      });
  }, [id]);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label mb-0">View Notification</h6>

              <button
                className="btn btn-secondary"
                onClick={() => navigate(-1)}
              >
                <i className="fa fa-arrow-left me-1"></i> Back
              </button>
            </div>
            {loader ? (
              <p className="mb-0">Loading...</p>
            ) : (
              <div className="row row-sm">
                <div className="col-md-6 form-group">
                  <label className="text-left d-flex">Title</label>
                  <input
                    className="form-control"
                    value={details?.title || ""}
                    disabled
                  />
                </div>
                <div className="col-md-6 form-group">
                  <label className="text-left d-flex">Sender Type</label>
                  <input
                    className="form-control"
                    value={details?.sender_type || ""}
                    disabled
                  />
                </div>
                <div className="col-md-12 form-group">
                  <label className="text-left d-flex">Message</label>
                  <textarea
                    className="form-control"
                    rows={4}
                    value={details?.message || ""}
                    disabled
                  />
                </div>
                <div className="col-md-6 form-group">
                  <label className="text-left d-flex">Redirect Type</label>
                  <input
                    className="form-control"
                    value={details?.redirect_type || "N/A"}
                    disabled
                  />
                </div>
                <div className="col-md-6 form-group">
                  <label className="text-left d-flex">Redirect Item ID</label>
                  <input
                    className="form-control"
                    value={details?.redirect_id || "N/A"}
                    disabled
                  />
                </div>
                <div className="col-md-6 form-group">
                  <label className="text-left d-flex">Broadcast</label>
                  <input
                    className="form-control"
                    value={details?.is_broadcast ? "Yes" : "No"}
                    disabled
                  />
                </div>
                <div className="col-md-6 form-group">
                  <label className="text-left d-flex">Created Date</label>
                  <input
                    className="form-control"
                    value={
                      details?.createdAt
                        ? formateDateWithMonth(details.createdAt)
                        : ""
                    }
                    disabled
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewNotification;
